var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20;
import { CardAdvancement, CardElement, CardFaction, CardRarity } from '@cta-portal/webapp-common/lib/api/schema';
// border Standard
import commonS1Border from '../assets/images/craft/border/border-common-s1.png';
import commonS2Border from '../assets/images/craft/border/border-common-s2.png';
import commonS3Border from '../assets/images/craft/border/border-common-s3.png';
import commonS1StandardBorder from '../assets/images/craft/border/border-common-standard-s1.png';
import commonS2StandardBorder from '../assets/images/craft/border/border-common-standard-s2.png';
import commonS3StandardBorder from '../assets/images/craft/border/border-common-standard-s3.png';
import exclusiveS1Border from '../assets/images/craft/border/border-exclusive-s1.png';
import exclusiveS2Border from '../assets/images/craft/border/border-exclusive-s2.png';
import exclusiveS3Border from '../assets/images/craft/border/border-exclusive-s3.png';
import exclusiveS1StandardBorder from '../assets/images/craft/border/border-exclusive-standard-s1.png';
import exclusiveS2StandardBorder from '../assets/images/craft/border/border-exclusive-standard-s2.png';
import exclusiveS3StandardBorder from '../assets/images/craft/border/border-exclusive-standard-s3.png';
import mythicS1Border from '../assets/images/craft/border/border-mythic-s1.png';
import mythicS2Border from '../assets/images/craft/border/border-mythic-s2.png';
import mythicS3Border from '../assets/images/craft/border/border-mythic-s3.png';
import mythicS1StandardBorder from '../assets/images/craft/border/border-mythic-standard-s1.png';
import mythicS2StandardBorder from '../assets/images/craft/border/border-mythic-standard-s2.png';
import mythicS3StandardBorder from '../assets/images/craft/border/border-mythic-standard-s3.png';
import rareS1Border from '../assets/images/craft/border/border-rare-s1.png';
import rareS2Border from '../assets/images/craft/border/border-rare-s2.png';
import rareS3Border from '../assets/images/craft/border/border-rare-s3.png';
import rareS1StandardBorder from '../assets/images/craft/border/border-rare-standard-s1.png';
import rareS2StandardBorder from '../assets/images/craft/border/border-rare-standard-s2.png';
import rareS3StandardBorder from '../assets/images/craft/border/border-rare-standard-s3.png';
import specialRareS1Border from '../assets/images/craft/border/border-specialrare-s1.png';
import specialRareS2Border from '../assets/images/craft/border/border-specialrare-s2.png';
import specialRareS3Border from '../assets/images/craft/border/border-specialrare-s3.png';
import specialRareS1StandardBorder from '../assets/images/craft/border/border-specialrare-standard-s1.png';
import specialRareS2StandardBorder from '../assets/images/craft/border/border-specialrare-standard-s2.png';
import specialRareS3StandardBorder from '../assets/images/craft/border/border-specialrare-standard-s3.png';
import ultraRareS1Border from '../assets/images/craft/border/border-ultrarare-s1.png';
import ultraRareS2Border from '../assets/images/craft/border/border-ultrarare-s2.png';
import ultraRareS3Border from '../assets/images/craft/border/border-ultrarare-s3.png';
import ultraRareS1StandardBorder from '../assets/images/craft/border/border-ultrarare-standard-s1.png';
import ultraRareS2StandardBorder from '../assets/images/craft/border/border-ultrarare-standard-s2.png';
import ultraRareS3StandardBorder from '../assets/images/craft/border/border-ultrarare-standard-s3.png';
import uncommonS1Border from '../assets/images/craft/border/border-uncommon-s1.png';
import uncommonS2Border from '../assets/images/craft/border/border-uncommon-s2.png';
import uncommonS3Border from '../assets/images/craft/border/border-uncommon-s3.png';
import uncommonS1StandardBorder from '../assets/images/craft/border/border-uncommon-standard-s1.png';
import uncommonS2StandardBorder from '../assets/images/craft/border/border-uncommon-standard-s2.png';
import uncommonS3StandardBorder from '../assets/images/craft/border/border-uncommon-standard-s3.png';
import uniqueS1Border from '../assets/images/craft/border/border-unique-s1.png';
import uniqueS2Border from '../assets/images/craft/border/border-unique-s2.png';
import uniqueS3Border from '../assets/images/craft/border/border-unique-s3.png';
import waterBackground from '../assets/images/craft/element/element-bkg-blue.png';
import earthBackground from '../assets/images/craft/element/element-bkg-brown.png';
import airBackground from '../assets/images/craft/element/element-bkg-cyan.png';
import lifeBackground from '../assets/images/craft/element/element-bkg-green.png';
import darkBackground from '../assets/images/craft/element/element-bkg-purple.png';
import fireBackground from '../assets/images/craft/element/element-bkg-red.png';
import lightBackground from '../assets/images/craft/element/element-bkg-yellow.png';
import waterElement from '../assets/images/craft/element/element-blue.png';
import earthElement from '../assets/images/craft/element/element-brown.png';
// element
import airElement from '../assets/images/craft/element/element-cyan.png';
import lifeElement from '../assets/images/craft/element/element-green.png';
import darkElement from '../assets/images/craft/element/element-purple.png';
import fireElement from '../assets/images/craft/element/element-red.png';
import lightElement from '../assets/images/craft/element/element-yellow.png';
// faction
import arkhanteFaction from '../assets/images/craft/faction/faction-arkhante.png';
import mantrisFaction from '../assets/images/craft/faction/faction-mantris.png';
import riftFaction from '../assets/images/craft/faction/faction-rift.png';
// grade
import commonS1Grade from '../assets/images/craft/grade/grade-01-common-s1.png';
import commonS2Grade from '../assets/images/craft/grade/grade-01-common-s2.png';
import commonS3Grade from '../assets/images/craft/grade/grade-01-common-s3.png';
import uncommonS1Grade from '../assets/images/craft/grade/grade-02-uncommon-s1.png';
import uncommonS2Grade from '../assets/images/craft/grade/grade-02-uncommon-s2.png';
import uncommonS3Grade from '../assets/images/craft/grade/grade-02-uncommon-s3.png';
import rareS1Grade from '../assets/images/craft/grade/grade-03-rare-s1.png';
import rareS2Grade from '../assets/images/craft/grade/grade-03-rare-s2.png';
import rareS3Grade from '../assets/images/craft/grade/grade-03-rare-s3.png';
import ultraRareS1Grade from '../assets/images/craft/grade/grade-04-ultra-rare-s1.png';
import ultraRareS2Grade from '../assets/images/craft/grade/grade-04-ultra-rare-s2.png';
import ultraRareS3Grade from '../assets/images/craft/grade/grade-04-ultra-rare-s3.png';
import mythicS1Grade from '../assets/images/craft/grade/grade-05-mythic-s1.png';
import mythicS2Grade from '../assets/images/craft/grade/grade-05-mythic-s2.png';
import mythicS3Grade from '../assets/images/craft/grade/grade-05-mythic-s3.png';
import exclusiveS1Grade from '../assets/images/craft/grade/grade-06-exclusive-s1.png';
import exclusiveS2Grade from '../assets/images/craft/grade/grade-06-exclusive-s2.png';
import exclusiveS3Grade from '../assets/images/craft/grade/grade-06-exclusive-s3.png';
import uniqueS1Grade from '../assets/images/craft/grade/grade-07-unique-s1.png';
import uniqueS2Grade from '../assets/images/craft/grade/grade-07-unique-s2.png';
import uniqueS3Grade from '../assets/images/craft/grade/grade-07-unique-s3.png';
import specialRareS1Grade from '../assets/images/craft/grade/grade-08-special-rare-s1.png';
import specialRareS2Grade from '../assets/images/craft/grade/grade-08-special-rare-s2.png';
import specialRareS3Grade from '../assets/images/craft/grade/grade-08-special-rare-s3.png';
export var elementAssets = (_a = {},
    _a[CardElement.AIR] = airElement,
    _a[CardElement.DARK] = darkElement,
    _a[CardElement.EARTH] = earthElement,
    _a[CardElement.FIRE] = fireElement,
    _a[CardElement.LIFE] = lifeElement,
    _a[CardElement.LIGHT] = lightElement,
    _a[CardElement.WATER] = waterElement,
    _a);
export var elementBackgroundAssets = (_b = {},
    _b[CardElement.AIR] = airBackground,
    _b[CardElement.DARK] = darkBackground,
    _b[CardElement.EARTH] = earthBackground,
    _b[CardElement.FIRE] = fireBackground,
    _b[CardElement.LIFE] = lifeBackground,
    _b[CardElement.LIGHT] = lightBackground,
    _b[CardElement.WATER] = waterBackground,
    _b);
export var factionAssets = (_c = {},
    _c[CardFaction.ARKHANTE] = arkhanteFaction,
    _c[CardFaction.MANTRIS] = mantrisFaction,
    _c[CardFaction.RIFT] = riftFaction,
    _c);
export var gradeAssets = (_d = {},
    _d[CardRarity.COMMON] = (_e = {},
        _e[CardFaction.ARKHANTE] = commonS1Grade,
        _e[CardFaction.MANTRIS] = commonS2Grade,
        _e[CardFaction.RIFT] = commonS3Grade,
        _e),
    _d[CardRarity.UNCOMMON] = (_f = {},
        _f[CardFaction.ARKHANTE] = uncommonS1Grade,
        _f[CardFaction.MANTRIS] = uncommonS2Grade,
        _f[CardFaction.RIFT] = uncommonS3Grade,
        _f),
    _d[CardRarity.RARE] = (_g = {},
        _g[CardFaction.ARKHANTE] = rareS1Grade,
        _g[CardFaction.MANTRIS] = rareS2Grade,
        _g[CardFaction.RIFT] = rareS3Grade,
        _g),
    _d[CardRarity.ULTRA_RARE] = (_h = {},
        _h[CardFaction.ARKHANTE] = ultraRareS1Grade,
        _h[CardFaction.MANTRIS] = ultraRareS2Grade,
        _h[CardFaction.RIFT] = ultraRareS3Grade,
        _h),
    _d[CardRarity.MYTHIC] = (_j = {},
        _j[CardFaction.ARKHANTE] = mythicS1Grade,
        _j[CardFaction.MANTRIS] = mythicS2Grade,
        _j[CardFaction.RIFT] = mythicS3Grade,
        _j),
    _d[CardRarity.EXCLUSIVE] = (_k = {},
        _k[CardFaction.ARKHANTE] = exclusiveS1Grade,
        _k[CardFaction.MANTRIS] = exclusiveS2Grade,
        _k[CardFaction.RIFT] = exclusiveS3Grade,
        _k),
    _d[CardRarity.UNIQUE] = (_l = {},
        _l[CardFaction.ARKHANTE] = uniqueS1Grade,
        _l[CardFaction.MANTRIS] = uniqueS2Grade,
        _l[CardFaction.RIFT] = uniqueS3Grade,
        _l),
    _d[CardRarity.SPECIAL_RARE] = (_m = {},
        _m[CardFaction.ARKHANTE] = specialRareS1Grade,
        _m[CardFaction.MANTRIS] = specialRareS2Grade,
        _m[CardFaction.RIFT] = specialRareS3Grade,
        _m),
    _d);
export var borderAssets = (_o = {},
    _o[CardRarity.COMMON] = (_p = {},
        _p[CardFaction.ARKHANTE] = (_q = {},
            _q[CardAdvancement.STANDARD] = commonS1StandardBorder,
            _q[CardAdvancement.ALTERNATIVE] = commonS1Border,
            _q[CardAdvancement.COMBO] = commonS1Border,
            _q),
        _p[CardFaction.MANTRIS] = (_r = {},
            _r[CardAdvancement.STANDARD] = commonS2StandardBorder,
            _r[CardAdvancement.ALTERNATIVE] = commonS2Border,
            _r[CardAdvancement.COMBO] = commonS2Border,
            _r),
        _p[CardFaction.RIFT] = (_s = {},
            _s[CardAdvancement.STANDARD] = commonS3StandardBorder,
            _s[CardAdvancement.ALTERNATIVE] = commonS3Border,
            _s[CardAdvancement.COMBO] = commonS3Border,
            _s),
        _p),
    _o[CardRarity.UNCOMMON] = (_t = {},
        _t[CardFaction.ARKHANTE] = (_u = {},
            _u[CardAdvancement.STANDARD] = uncommonS1StandardBorder,
            _u[CardAdvancement.ALTERNATIVE] = uncommonS1Border,
            _u[CardAdvancement.COMBO] = uncommonS1Border,
            _u),
        _t[CardFaction.MANTRIS] = (_v = {},
            _v[CardAdvancement.STANDARD] = uncommonS2StandardBorder,
            _v[CardAdvancement.ALTERNATIVE] = uncommonS2Border,
            _v[CardAdvancement.COMBO] = uncommonS2Border,
            _v),
        _t[CardFaction.RIFT] = (_w = {},
            _w[CardAdvancement.STANDARD] = uncommonS3StandardBorder,
            _w[CardAdvancement.ALTERNATIVE] = uncommonS3Border,
            _w[CardAdvancement.COMBO] = uncommonS3Border,
            _w),
        _t),
    _o[CardRarity.RARE] = (_x = {},
        _x[CardFaction.ARKHANTE] = (_y = {},
            _y[CardAdvancement.STANDARD] = rareS1StandardBorder,
            _y[CardAdvancement.ALTERNATIVE] = rareS1Border,
            _y[CardAdvancement.COMBO] = rareS1Border,
            _y),
        _x[CardFaction.MANTRIS] = (_z = {},
            _z[CardAdvancement.STANDARD] = rareS2StandardBorder,
            _z[CardAdvancement.ALTERNATIVE] = rareS2Border,
            _z[CardAdvancement.COMBO] = rareS2Border,
            _z),
        _x[CardFaction.RIFT] = (_0 = {},
            _0[CardAdvancement.STANDARD] = rareS3StandardBorder,
            _0[CardAdvancement.ALTERNATIVE] = rareS3Border,
            _0[CardAdvancement.COMBO] = rareS3Border,
            _0),
        _x),
    _o[CardRarity.ULTRA_RARE] = (_1 = {},
        _1[CardFaction.ARKHANTE] = (_2 = {},
            _2[CardAdvancement.STANDARD] = ultraRareS1StandardBorder,
            _2[CardAdvancement.ALTERNATIVE] = ultraRareS1Border,
            _2[CardAdvancement.COMBO] = ultraRareS1Border,
            _2),
        _1[CardFaction.MANTRIS] = (_3 = {},
            _3[CardAdvancement.STANDARD] = ultraRareS2StandardBorder,
            _3[CardAdvancement.ALTERNATIVE] = ultraRareS2Border,
            _3[CardAdvancement.COMBO] = ultraRareS2Border,
            _3),
        _1[CardFaction.RIFT] = (_4 = {},
            _4[CardAdvancement.STANDARD] = ultraRareS3StandardBorder,
            _4[CardAdvancement.ALTERNATIVE] = ultraRareS3Border,
            _4[CardAdvancement.COMBO] = ultraRareS3Border,
            _4),
        _1),
    _o[CardRarity.MYTHIC] = (_5 = {},
        _5[CardFaction.ARKHANTE] = (_6 = {},
            _6[CardAdvancement.STANDARD] = mythicS1StandardBorder,
            _6[CardAdvancement.ALTERNATIVE] = mythicS1Border,
            _6[CardAdvancement.COMBO] = mythicS1Border,
            _6),
        _5[CardFaction.MANTRIS] = (_7 = {},
            _7[CardAdvancement.STANDARD] = mythicS2StandardBorder,
            _7[CardAdvancement.ALTERNATIVE] = mythicS2Border,
            _7[CardAdvancement.COMBO] = mythicS2Border,
            _7),
        _5[CardFaction.RIFT] = (_8 = {},
            _8[CardAdvancement.STANDARD] = mythicS3StandardBorder,
            _8[CardAdvancement.ALTERNATIVE] = mythicS3Border,
            _8[CardAdvancement.COMBO] = mythicS3Border,
            _8),
        _5),
    _o[CardRarity.EXCLUSIVE] = (_9 = {},
        _9[CardFaction.ARKHANTE] = (_10 = {},
            _10[CardAdvancement.STANDARD] = exclusiveS1StandardBorder,
            _10[CardAdvancement.ALTERNATIVE] = exclusiveS1Border,
            _10[CardAdvancement.COMBO] = exclusiveS1Border,
            _10),
        _9[CardFaction.MANTRIS] = (_11 = {},
            _11[CardAdvancement.STANDARD] = exclusiveS2StandardBorder,
            _11[CardAdvancement.ALTERNATIVE] = exclusiveS2Border,
            _11[CardAdvancement.COMBO] = exclusiveS2Border,
            _11),
        _9[CardFaction.RIFT] = (_12 = {},
            _12[CardAdvancement.STANDARD] = exclusiveS3StandardBorder,
            _12[CardAdvancement.ALTERNATIVE] = exclusiveS3Border,
            _12[CardAdvancement.COMBO] = exclusiveS3Border,
            _12),
        _9),
    _o[CardRarity.UNIQUE] = (_13 = {},
        _13[CardFaction.ARKHANTE] = (_14 = {},
            _14[CardAdvancement.STANDARD] = uniqueS1Border,
            _14[CardAdvancement.ALTERNATIVE] = uniqueS1Border,
            _14[CardAdvancement.COMBO] = uniqueS1Border,
            _14),
        _13[CardFaction.MANTRIS] = (_15 = {},
            _15[CardAdvancement.STANDARD] = uniqueS2Border,
            _15[CardAdvancement.ALTERNATIVE] = uniqueS2Border,
            _15[CardAdvancement.COMBO] = uniqueS2Border,
            _15),
        _13[CardFaction.RIFT] = (_16 = {},
            _16[CardAdvancement.STANDARD] = uniqueS3Border,
            _16[CardAdvancement.ALTERNATIVE] = uniqueS3Border,
            _16[CardAdvancement.COMBO] = uniqueS3Border,
            _16),
        _13),
    _o[CardRarity.SPECIAL_RARE] = (_17 = {},
        _17[CardFaction.ARKHANTE] = (_18 = {},
            _18[CardAdvancement.STANDARD] = specialRareS1StandardBorder,
            _18[CardAdvancement.ALTERNATIVE] = specialRareS1Border,
            _18[CardAdvancement.COMBO] = specialRareS1Border,
            _18),
        _17[CardFaction.MANTRIS] = (_19 = {},
            _19[CardAdvancement.STANDARD] = specialRareS2StandardBorder,
            _19[CardAdvancement.ALTERNATIVE] = specialRareS2Border,
            _19[CardAdvancement.COMBO] = specialRareS2Border,
            _19),
        _17[CardFaction.RIFT] = (_20 = {},
            _20[CardAdvancement.STANDARD] = specialRareS3StandardBorder,
            _20[CardAdvancement.ALTERNATIVE] = specialRareS3Border,
            _20[CardAdvancement.COMBO] = specialRareS3Border,
            _20),
        _17),
    _o);
